import Api from 'shared/core/api'

export default {
  submit (formData) {
    return Api().post('/bicyclepermit', formData);
  }
}
